// Segmentschalter für 2–4 Optionen (Handoff §4): aktive Option als weiße Pille mit dunkler Schrift.
// Tastatur wie components/ui/Segment: Pfeil links/rechts wechselt.
import type { KeyboardEvent, ReactNode } from 'react';
import { FeldHuelle } from './FormFeld';
import { useViewport } from '../hooks';
import { SEGMENT } from './form-stil';

export interface FormSegmentOption<K extends string> { wert: K; label: ReactNode; tip?: string }

export interface FormSegmentProps<K extends string> {
  label: string;
  optionen: readonly FormSegmentOption<K>[];
  /** '' = nichts gewählt */
  wert: K | '';
  onChange: (wert: K) => void;
  pflicht?: boolean;
  fehler?: boolean;
  tip?: string;
  /** Beschriftung nur für Screenreader */
  ohneBeschriftung?: boolean;
}

export function FormSegment<K extends string>({ label, optionen, wert, onChange, pflicht, fehler, tip, ohneBeschriftung }: FormSegmentProps<K>) {
  // Schmal: kleinere Schrift; Texte werden nie abgeschnitten, notfalls umbrochen (Silbentrennung).
  const schmal = useViewport().width < 600;
  const tastatur = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const i = optionen.findIndex(o => o.wert === wert);
    const n = optionen.length;
    const naechste = optionen[(i + (e.key === 'ArrowRight' ? 1 : n - 1) + n) % n];
    if (naechste) onChange(naechste.wert);
  };
  return (
    <FeldHuelle label={ohneBeschriftung ? undefined : label} pflicht={pflicht} fehler={fehler} tip={tip}>
      <div role="radiogroup" aria-label={label} onKeyDown={tastatur} className="flex" style={{
        padding: 3, marginTop: 3, borderRadius: 12, background: SEGMENT.behaelter, boxShadow: SEGMENT.behaelterRing,
      }}>
        {optionen.map(o => {
          const an = o.wert === wert;
          return (
            <button key={o.wert} type="button" role="radio" aria-checked={an} tabIndex={an || (!optionen.some(x => x.wert === wert) && o === optionen[0]) ? 0 : -1} data-tip={o.tip}
              onClick={() => onChange(o.wert)}
              className="flex min-w-0 flex-1 cursor-pointer items-center justify-center border-none text-center"
              style={{
                font: 'inherit', minHeight: 32, padding: schmal ? '3px 4px' : '3px 8px', borderRadius: 9,
                background: an ? SEGMENT.aktiv : 'transparent', color: an ? SEGMENT.aktivText : SEGMENT.text,
                boxShadow: an ? SEGMENT.aktivSchatten : 'none',
                transition: 'background .25s cubic-bezier(.32,.72,0,1), color .2s',
              }}>
              <span lang="de" style={{ fontSize: schmal ? 11.5 : 12.5, fontWeight: 700, lineHeight: 1.15, hyphens: 'auto', overflowWrap: 'break-word', minWidth: 0 }}>{o.label}</span>
            </button>
          );
        })}
      </div>
    </FeldHuelle>
  );
}
